import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { extractValueFromParams } from '@awp/core/utils';

@Injectable({
  providedIn: 'root'
})
export class ThemeResolver implements Resolve<any> {

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    let themeId = extractValueFromParams(route, 'themeId');
    return of({ themeId });
  }
}